import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { home } from "../../../api/requests";
import styles from "./styles/onlinePlayers.module.scss";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

var OnlinePLayers = function OnlinePLayers() {
  var _onlinePlayers$Curren;

  var _useState = useState(""),
      onlinePlayers = _useState[0],
      setOnlinePlayers = _useState[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  useEffect(function () {
    home().then(function (res) {
      // console.log("homme api res: ",res.data)
      setOnlinePlayers(res.data);
    })["catch"](function (err) {
      return console.log("online players error: ", err);
    });
  }, []);

  var sliceDate = function sliceDate(str) {
    var result = str.slice(0, str.length - 7);
    return result;
  };

  return /*#__PURE__*/_jsx("div", {
    children: onlinePlayers && onlinePlayers.CurrentUsers > 0 && /*#__PURE__*/_jsxs("div", {
      className: styles.onlinePlayersWrapper,
      children: [/*#__PURE__*/_jsx("h2", {
        className: styles.title,
        children: t('home:Who is online playing WoW?')
      }), /*#__PURE__*/_jsx("table", {
        className: "table table-striped mt-4 ".concat(styles.table),
        children: /*#__PURE__*/_jsx("tbody", {
          children: onlinePlayers === null || onlinePlayers === void 0 ? void 0 : (_onlinePlayers$Curren = onlinePlayers.CurrentContests) === null || _onlinePlayers$Curren === void 0 ? void 0 : _onlinePlayers$Curren.map(function (item, index) {
            var _item$ContestProfile;

            return /*#__PURE__*/_jsx(Link, {
              href: {
                pathname: "/profile/".concat(item.Counter),
                query: {
                  name: item.FullName
                }
              },
              children: /*#__PURE__*/_jsx("tr", {
                className: styles.row,
                children: /*#__PURE__*/_jsxs("td", {
                  children: [/*#__PURE__*/_jsx("img", {
                    className: "".concat(styles.image),
                    src: 'images/table/profile.png'
                  }), /*#__PURE__*/_jsx("p", {
                    className: styles.name,
                    style: {
                      padding: isRTL ? '0 20px 0 0' : '0 0 0 20px'
                    },
                    children: item.FullName
                  }), /*#__PURE__*/_jsxs("p", {
                    className: "".concat(styles.date, " ").concat(isRTL ? styles.dateFa : ''),
                    children: [t('home:Last Seen'), ": ", item === null || item === void 0 ? void 0 : (_item$ContestProfile = item.ContestProfile) === null || _item$ContestProfile === void 0 ? void 0 : _item$ContestProfile.LastSeen]
                  })]
                })
              })
            }, index);
          })
        })
      })]
    })
  });
};

export default OnlinePLayers;